module.exports = __webpack_public_path__ + "static/media/scroll_rendering_for_sign_border_2015.bcb5a1d6.webp";